import { useEffect, useState } from 'react';
import groupBy from 'lodash/groupBy';
import values from 'lodash/values';

export function useDraftPickList(initialName = '', initialItems = null) {
  const [draftPickListItems, setDraftPickListItems] = useState([]);
  const [name, setName] = useState('');

  useEffect(() => {
    if (initialItems?.length) {
      setDraftPickListItems(initialItems);
    }
    if (initialName) {
      setName(initialName);
    }
  }, []);

  const isItemInDraftPickList = (item) => {
    const inPickList = !!draftPickListItems.find(
      (draftItem) => draftItem.InventoryItemID === item.InventoryItemID
    );

    return inPickList && item.PickListID === null;
  };

  const handleAddToPickList = (item) => {
    if (!isItemInDraftPickList(item)) {
      setDraftPickListItems((draftItems) => [...draftItems, item]);
    }
  };

  const handleRemoveFromPickList = (item) => {
    setDraftPickListItems((draftItems) =>
      draftItems.filter(
        (draftItem) => draftItem.InventoryItemID !== item.InventoryItemID
      )
    );
  };

  const groupedItems = values(
    groupBy(draftPickListItems, (item) => {
      let result = item.InventoryItemID;
      if (item.GroupID !== null) {
        result = item.GroupID;
      }
      return result;
    })
  );

  return {
    items: draftPickListItems,
    itemsGrouped: groupedItems,
    name,
    isItemInDraftPickList,
    handleAddToPickList,
    handleRemoveFromPickList,
    handleNameChange: (pickListName) => {
      setName(pickListName);
    },
  };
}
